import useEvmScAccount from '@/shared/hooks/useEvmScAccount';
import useSharedOperatorsAndAuction from '@/shared/hooks/useOperatorsAndAuction';

export { type OperatorSummary } from '@/shared/hooks/useOperatorsAndAuction';

/** @deprecated Use `useOperatorsAndAuctionV2` instead. This hook will be removed in the future. */
export default function useOperatorsAndAuction({
  refetchInterval,
}: {
  refetchInterval?: number;
} = {}) {
  const { idSs58: delegatorIdSs58 } = useEvmScAccount();

  return useSharedOperatorsAndAuction({ delegatorIdSs58, refetchInterval });
}
